import {
  UserOutlined,
  VideoCameraOutlined,
  PoweroffOutlined,
  KeyOutlined,
  InsertRowRightOutlined,
  DollarOutlined,
  AuditOutlined,
  CreditCardOutlined,
  BellOutlined,
  ScheduleOutlined
} from "@ant-design/icons";
import { logout } from "@utils/logout";
import { Link } from "react-router-dom";
import { Avatar, Badge } from "antd";
import { apiUrl } from "@utils/apoloClient";
import ChangePassword from "@general/changePassword";
import bthDayHat from "@assets/imgs/bth-hat.png";
export const userVerticalMenuItems = (notifCount) => [
  {
    key: "dashboard",
    icon: <UserOutlined />,
    label: <Link to="/dashboard">داشبورد</Link>,
  },
  {
    key: "profile",
    icon: <VideoCameraOutlined />,
    label: <Link to="/profile">پروفایل</Link>,
  },
  {
    key: "my-services",
    icon: <ScheduleOutlined />,
    label: <Link to="/my-services">سرویس‌های من</Link>,
  },
  {
    key: "services",
    icon: <InsertRowRightOutlined />,
    label: <Link to="/services">خدمات</Link>,
  },
  {
    key: "transactions",
    icon: <DollarOutlined />,
    label: <Link to="/transactions">تراکنش ها</Link>,
  },
  {
    key: "invoices",
    icon: <AuditOutlined />,
    label: <Link to={`/invoices`}>فاکتورها</Link>,
  },
  {
    label: (
      <Badge count={notifCount} showZero={false} color="#09e406" overflowCount={10} offset={[-10, 0]}>
        <Link to="/notifications" className="notifsMenuItem">
          صندوق پیام
        </Link>
      </Badge>
    ),
    icon: <BellOutlined />,
    key: "notifications",
  },
  {
    key: "exit",
    icon: <PoweroffOutlined />,
    label: <span onClick={logout}>خروج</span>,
  },
];

export const userHorizontalMenuItems = (profileImg, name, notifCount) => {
  return [
    {
      key: "1",
      icon: profileImg ? (

        <Avatar src={apiUrl + profileImg} />

      ) : (
        <Avatar icon={<UserOutlined style={{ margin: 0 }} />} />
      ),
      label: name ? `خوش آمدی ${name} جان` : "خوش آمدی",
      children: [
        {
          label: <ChangePassword> تغییر رمز عبور</ChangePassword>,
          icon: <KeyOutlined />,
          key: "change-pass",
        },
        {
          label: <Link to="/setting/card">کارت عضویت</Link>,
          icon: <CreditCardOutlined />,
          key: "setting",
        },

        {
          label: (
            <span onClick={logout} style={{ width: "100%", height: "100%" }}>
              خروج
            </span>
          ),
          icon: <PoweroffOutlined onClick={logout} />,
          key: "exit",
        },

      ],
    },

    {
      key: '2',
      icon: <Link to="/notifications"> <Badge count={notifCount} color="green"> <BellOutlined style={{ color: "grey", fontSize: "18px" }} /></Badge></Link>,
      children: []
    }
  ];
};
